module.exports = __webpack_public_path__ + "static/media/openssidaypreparations.6f92de8e.jpeg";